// Client-safe component map for App Router

import { BYOCClientWrapper, NextjsContentSdkComponent, FEaaSClientWrapper } from '@sitecore-content-sdk/nextjs';
import { Form } from '@sitecore-content-sdk/nextjs';

import * as VideoComponent from 'src/components/video-component/VideoComponent';
import * as RowSplitter from 'src/components/sxa/row-splitter/RowSplitter';
import * as RichText from 'src/components/sxa/rich-text/RichText';
import * as Navigation from 'src/components/sxa/navigation/Navigation';
import * as LinkList from 'src/components/sxa/link-list/LinkList';
import * as Image from 'src/components/sxa/image/Image';
import * as TwoColumnSplitter from 'src/components/sxa/column-splitter/TwoColumnSplitter';
import * as ThreeColumnSplitter from 'src/components/sxa/column-splitter/ThreeColumnSplitter';
import * as FourColumnSplitter from 'src/components/sxa/column-splitter/FourColumnSplitter';
import * as FiveColumnSplitter from 'src/components/sxa/column-splitter/FiveColumnSplitter';
import * as ColumnSplitter from 'src/components/sxa/column-splitter/ColumnSplitter';
import * as SSOSignIn from 'src/components/sso-sign-in/SSOSignIn';
import * as SectionHeader from 'src/components/section-header/SectionHeader';
import * as ProgressiveProfilePopup from 'src/components/progressive-profile-popup/ProgressiveProfilePopup';
import * as MegaMenu from 'src/components/mega-menu/MegaMenu';
import * as LanguagePicker from 'src/components/language-picker/LanguagePicker';
import * as HeroCarousel from 'src/components/hero-carousel/HeroCarousel';
import * as ContactCard from 'src/components/contact-card/ContactCard';
import * as StoriesDetails from 'src/components/ch/stories-details/StoriesDetails';
import * as NewsDetails from 'src/components/ch/news-details/NewsDetails';
import * as LocationDetails from 'src/components/ch/location-details/LocationDetails';
import * as EventDetails from 'src/components/ch/event-details/EventDetails';
import * as ArticleDetails from 'src/components/ch/article-details/ArticleDetails';
import * as CardStack from 'src/components/card-stack/CardStack';
import * as SearchSummary from 'src/components/Search/search-summary/SearchSummary';
import * as SearchSortFacet from 'src/components/Search/search-sort-facet/SearchSortFacet';
import * as SearchSort from 'src/components/Search/search-sort/SearchSort';
import * as useSearchResultsState from 'src/components/Search/search-results/useSearchResultsState';
import * as SearchResultsShell from 'src/components/Search/search-results/SearchResultsShell';
import * as SearchResults from 'src/components/Search/search-results/SearchResults';
import * as CustomNoResult from 'src/components/Search/search-results/CustomNoResult';
import * as SearchPager from 'src/components/Search/search-pager/SearchPager';
import * as useCatalogFilter from 'src/components/Search/search-filter/useCatalogFilter';
import * as SearchFilterSolutionCatalog from 'src/components/Search/search-filter/SearchFilterSolutionCatalog';
import * as SearchFilterOfferingCatalog from 'src/components/Search/search-filter/SearchFilterOfferingCatalog';
import * as SearchFilter from 'src/components/Search/search-filter/SearchFilter';
import * as SearchFacet from 'src/components/Search/search-facet/SearchFacet';
import * as SearchContainer from 'src/components/Search/search-container/SearchContainer';
import * as SearchBreadbox from 'src/components/Search/search-breadbox/SearchBreadbox';
import * as SearchBox from 'src/components/Search/search-box/SearchBox';
import * as ContextualCardCarousel from 'src/components/Search/card-carousel/ContextualCardCarousel';
import * as CardCarouselclient from 'src/components/Search/card-carousel/CardCarousel.client';
import * as CardCarousel from 'src/components/Search/card-carousel/CardCarousel';
import * as ModalDialog from 'src/components/Modal/ModalDialog';
import * as Script from 'src/components/Metadata/Script/Script';
import * as Gtm from 'src/components/Metadata/Gtm/Gtm';
import * as Link from 'src/components/Link/Link';
import * as Iframe from 'src/components/Iframe/Iframe';
import * as FormReferringUrl from 'src/components/Forms/FormReferringUrl';
import * as ChatbotScripts from 'src/components/Chatbot/ChatbotScripts';
import * as CardVideoModal from 'src/components/Card/CardVideoModal';
import * as Card from 'src/components/Card/Card';
import * as AccordionItem from 'src/components/Accordion/AccordionItem';
import * as Accordion from 'src/components/Accordion/Accordion';

export const componentMap = new Map<string, NextjsContentSdkComponent>([
  ['BYOCWrapper', BYOCClientWrapper],
  ['FEaaSWrapper', FEaaSClientWrapper],
  ['Form', Form],
  ['VideoComponent', { ...VideoComponent }],
  ['RowSplitter', { ...RowSplitter }],
  ['RichText', { ...RichText }],
  ['Navigation', { ...Navigation }],
  ['LinkList', { ...LinkList }],
  ['Image', { ...Image }],
  ['TwoColumnSplitter', { ...TwoColumnSplitter }],
  ['ThreeColumnSplitter', { ...ThreeColumnSplitter }],
  ['FourColumnSplitter', { ...FourColumnSplitter }],
  ['FiveColumnSplitter', { ...FiveColumnSplitter }],
  ['ColumnSplitter', { ...ColumnSplitter }],
  ['SSOSignIn', { ...SSOSignIn }],
  ['SectionHeader', { ...SectionHeader }],
  ['ProgressiveProfilePopup', { ...ProgressiveProfilePopup }],
  ['MegaMenu', { ...MegaMenu }],
  ['LanguagePicker', { ...LanguagePicker }],
  ['HeroCarousel', { ...HeroCarousel }],
  ['ContactCard', { ...ContactCard }],
  ['StoriesDetails', { ...StoriesDetails }],
  ['NewsDetails', { ...NewsDetails }],
  ['LocationDetails', { ...LocationDetails }],
  ['EventDetails', { ...EventDetails }],
  ['ArticleDetails', { ...ArticleDetails }],
  ['CardStack', { ...CardStack }],
  ['SearchSummary', { ...SearchSummary }],
  ['SearchSortFacet', { ...SearchSortFacet }],
  ['SearchSort', { ...SearchSort }],
  ['useSearchResultsState', { ...useSearchResultsState }],
  ['SearchResultsShell', { ...SearchResultsShell }],
  ['SearchResults', { ...SearchResults }],
  ['CustomNoResult', { ...CustomNoResult }],
  ['SearchPager', { ...SearchPager }],
  ['useCatalogFilter', { ...useCatalogFilter }],
  ['SearchFilterSolutionCatalog', { ...SearchFilterSolutionCatalog }],
  ['SearchFilterOfferingCatalog', { ...SearchFilterOfferingCatalog }],
  ['SearchFilter', { ...SearchFilter }],
  ['SearchFacet', { ...SearchFacet }],
  ['SearchContainer', { ...SearchContainer }],
  ['SearchBreadbox', { ...SearchBreadbox }],
  ['SearchBox', { ...SearchBox }],
  ['ContextualCardCarousel', { ...ContextualCardCarousel }],
  ['CardCarousel', { ...CardCarouselclient, ...CardCarousel }],
  ['ModalDialog', { ...ModalDialog }],
  ['Script', { ...Script }],
  ['Gtm', { ...Gtm }],
  ['Link', { ...Link }],
  ['Iframe', { ...Iframe }],
  ['FormReferringUrl', { ...FormReferringUrl }],
  ['ChatbotScripts', { ...ChatbotScripts }],
  ['CardVideoModal', { ...CardVideoModal }],
  ['Card', { ...Card }],
  ['AccordionItem', { ...AccordionItem }],
  ['Accordion', { ...Accordion }],
]);

export default componentMap;
